import React from 'react';
import { useTranslations } from '../utils/translations';
import illustrationImage from '../assets/illustration.png';
import './LoadingScreen.css';

const LoadingScreen = ({ currentLanguage = 'en' }) => {
  const { t } = useTranslations(currentLanguage);

  return (
    <div className="loading-screen" style={{ backgroundImage: `url(${illustrationImage})` }}>
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        
        <div className="loading-content">
          <h2 className="loading-title">
            Loading E-Learning Module...
          </h2>
          <p className="loading-message">
            Please wait...
          </p>
          <div className="loading-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
